<template>
  <div class="home-page">
    <HomeV2 v-if="!isLoading && !is_homepage_v2_exp"/>
    <HomeV2Exp v-if="!isLoading && is_homepage_v2_exp"/>
  </div>
</template>
<script>
import HomeV2 from './Home';
import HomeV2Exp from './HomeExp';

export default {
  name: 'HomeWrapper',
  components: {
    HomeV2,
    HomeV2Exp,
  },
  data() {
    return {
      is_homepage_v2_exp: false,
      isLoading: true,
    };
  },
  beforeMount() {
    this.getFeatureFlag();
  },
  methods: {
    async getFeatureFlag() {
      const newFlowFlag = await this.$optimizely.loadFeatureAsync(this.$store, 'homepage_v2', false);
      this.isLoading = false;
      this.is_homepage_v2_exp = newFlowFlag;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.home-page {
  background-color: $bg-color;
}
</style>
